import React from 'react';
import { BadgeCounterProps } from './badge-counter.types';
import { useStyles } from './badge-counter.styles';

export const BadgeCounter: React.FC<BadgeCounterProps> = (props): JSX.Element => {
  const { additionalUsersCount } = props;
  const useStyle = useStyles();
  return <div className={useStyle.highlightUserStar}>{additionalUsersCount}</div>;
};
